"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _i18n = require("../../../i18n");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
var _DetailsMessage = _interopRequireDefault(require("./DetailsMessage"));
var _PanelMessage = _interopRequireDefault(require("./PanelMessage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SuccessPanelHeader = () => {
  const {
    T
  } = (0, _i18n.useTranslation)();
  const {
    isOpen
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const translationLabel = isOpen ? 'reportReadyDetails' : 'reportReadyWithLink';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledIcon, {
    size: 165
  }), /*#__PURE__*/_react.default.createElement(_PanelMessage.default, {
    i18nKey: "notifications.reportReady"
  }), /*#__PURE__*/_react.default.createElement(ReportReadyDetails, null, T.translate(`notifications.${translationLabel}`)));
};
const StyledIcon = (0, _styledComponents.default)(_alloyReactIcon.CheckmarkCircleIcon)`
  color: ${_alloyReactTheme.default.colors.green500};
  stroke: ${_alloyReactTheme.default.colors.white};
`;
const ReportReadyDetails = (0, _styledComponents.default)(_DetailsMessage.default)`
  margin-bottom: 40px;
`;
var _default = exports.default = SuccessPanelHeader;